import { OnInit, Component } from '@angular/core';

@Component({
    selector: 'module',
    templateUrl: 'page-not-found.component.html'
})
export class PageNotFoundComponent implements OnInit {
    ngOnInit(): void {

    }
}



// WEBPACK FOOTER //
// ./src/app/components/page-not-found/page-not-found.component.ts